import type { RegexPattern } from '../types';

/**
 * @group Constants
 * @summary <blockquote>Regex patterns for color format validation.</blockquote>
 * 
 * Patterns used to validate and parse color formats (hex, RGB, etc.)
 */
export const COLOR_PATTERNS = {
  /**
   * Matches hexadecimal color strings (with or without # prefix)
   * Example: "#ff8000" or "ff8000"
   */
  HEX_COLOR: {
    regex: /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i,
    description: 'Matches hexadecimal color strings (with or without # prefix)',
    examples: ['#ff8000', 'ff8000', '#ABC123', 'abc123'],
    counterExamples: ['#ff80', 'ff80', '#gggggg', 'invalid'],
  } as RegexPattern,
} as const;
